module.exports = __webpack_public_path__ + "static/media/Katt.d62490e7.PNG";